import type { IconNode } from '../types';

/**
 * @name ligature-square
 * @description Lucide Lab SVG icon node.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cmVjdCB3aWR0aD0iMTgiIGhlaWdodD0iMTgiIHg9IjMiIHk9IjMiIHJ4PSIyIiAvPgogIDxwYXRoIGQ9Ik03IDEyaDMiIC8+CiAgPHBhdGggZD0iTTE0LjQgOGEzLjUgMy41IDAgMCAwLTUuOSAyLjVWMTciIC8+CiAgPHBhdGggZD0iTTEwIDE3SDciIC8+CiAgPHBhdGggZD0iTTE0IDEyaDEuNXY1IiAvPgogIDxwYXRoIGQ9Ik0xNyAxN2gtMyIgLz4KPC9zdmc+Cg==) - https://lucide.dev/icons/ligature-square
 * @see https://lucide.dev/guide/packages/lucide - Documentation
 *
 * @returns {Array}
 *
 */
const ligatureSquare: IconNode = [
  ['rect', { width: '18', height: '18', x: '3', y: '3', rx: '2', key: 'afitv7' }],
  ['path', { d: 'M7 12h3', key: '99ujjs' }],
  ['path', { d: 'M14.4 8a3.5 3.5 0 0 0-5.9 2.5V17', key: 'f1pr2v' }],
  ['path', { d: 'M10 17H7', key: '1ah28z' }],
  ['path', { d: 'M14 12h1.5v5', key: '1hj2r7' }],
  ['path', { d: 'M17 17h-3', key: '8c2xoh' }],
];

export default ligatureSquare;
